import React ,{useState ,useEffect } from 'react'
import { Container, Row, Col, Card, Form, Button, ButtonGroup, Modal } from 'react-bootstrap';
import PageTitle from '../components/common/PageTitle'
import api from '../../src/api/api'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import './SupplierSensors.css';

const SupplierSensors = () => {

    const { t } = useTranslation();
    const [toggle, setToggle] = useState(false)
    const [sensorId, setSensorId] = useState(null)
const navigate = useNavigate()
    const [settingValues, setSettingValues] = useState([])
    const [frequency, setFrequency] = useState('')
    const [dateSetting, setDateSetting] = useState([])
    const [minSetting, setMinSetting] = useState({})
    const [maxSetting, setMaxSetting] = useState({})
    const [simSettings, setSimSettings] = useState({
      simNumber: "",
      simIdentify: ""
    })
    const [formValid, setFormValid] = useState(false);
    const [resultScan, setResultScan] = useState('')
    const [sensorCoords, setSensorCoords] = useState({
      lat: '',
      lon: '',
      locationInfo: {}
    })
    const [existSuppliers,setExistSuppliers] = useState([])
    const [supplierUid,setSupplierUid] = useState('')
    const [allSensors, setAllSensors] = useState([])
    const [users,setUsers] = useState([])
    const [userUid,setUserUid] = useState('')
    const [singleSensor,setSingleSensor] = useState([])
    const [code,setCode] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [search, setSearch] = useState('')
    const getAllSensors = async () => {
        await api.get('/supplier/get-sensors')
            .then(response => {
                let sensorsData = response.data.sensors
                setAllSensors(sensorsData)
            }).catch(err => {
                console.error(err)
            }).finally(() => {
                setIsLoading(false)
            })
    }
    const getExistSuppliers = async () => {
        await api.get('/admin/exist-suppliers')
            .then(response => {
                var Data = response.data.suppliers
                setExistSuppliers(Data)
                setSupplierUid(Data.uid)
   
            }).catch(err => {
                console.error(err)
            })
    }

    useEffect(()=>{
        getAllSensors()
        getMyUsers ()
        getExistSuppliers()
    },[])

    const getMyUsers = async () => {
        await api.get('/supplier/get-users')
        .then(response =>{
            let usersList = response.data.users
            setUsers(usersList)
        }).catch(err =>{
            console.error(err)
        })
    }

    const getSingleSensor = async (sensorid,type) => {

        await api.get(`/admin/single-sensor/${sensorid}`)
            .then(res => {
                let sensorData = res.data.sensor
                setSingleSensor(sensorData) 
                setCode(sensorData.code)  
                    users.map(user=>{
                        if(user.id === sensorData.user_id){
                            setUserUid(user.uid)
                        }
                    })
                    existSuppliers.map(supplier=>{
                        if(supplier.id === sensorData.supplier_id){
                            setSupplierUid(supplier.uid)
                        }
                    })
            }).catch(error => {
                swal({
                    title: t("Error"),
                    icon: "error",

                });

            })
        setToggle(!toggle)
        if(type === "User") {
            getMyUsers()
        }
    }

    const getSingleSensorToModif = async (id) => {
        if(id){
            await api.get(`/sensor/single-sensor/${id}`)
               .then(res => {
                 let SensorData = res.data.sensor
                 let SensorLocation = res.data.location
                 setResultScan(SensorData.code)
                 setSensorCoords({ lat: SensorData.Latitude, lon: SensorData.Longitude, locationInfo: SensorLocation })
                 setSensorId(id)
                 let dataMapping = SensorData.dataMapping
                 if (dataMapping.length > 0) {
                   setSettingValues(dataMapping)
                   dataMapping.map(data => {
                     let frequency = data.frequency
                     setFrequency(frequency)
                     setSimSettings({ simIdentify: data.simIdentify, simNumber: data.simNumber })
                     setDateSetting(data.date)
                     setMinSetting(data.min)
                     setMaxSetting(data.max)
         
                   })
                   // dataArray.push({date : data.date, min : data.min, max : data.max})
         
                 }
         
         
               }).catch(error => {
                 swal({
                   title: t("Error"),
                   icon: "error",
         
                 });
         
               })
    
        }
      }

    const assignSensorToUser = (userUid,supplierUid) =>{
        let data ={
            code : code,
            user_uid : userUid,
            supplier_uid : supplierUid

        }
        api.post('/admin/edit-sensor',data)
        .then(response =>{
            if(response.data.type === 'success'){
                swal(`${t('sensor_updated')}`, {
                    icon: "success",
                });
                setToggle(false)
                getAllSensors()
            }
            if(response.data.type === 'danger'){
                swal({
                    icon: 'error',
                    title: t('Oops...'),
                    text: t('Error')
                })

            }
        }).catch(err=>{
            swal({
                icon: 'error',
                title: t('Oops...'),
                text: t('Error')
            })
        })
    }

    const validateForm = () => {
        // Check if the sensor code, frequency, and date inputs are not empty
        const isCodeValid = resultScan.trim() !== "";
        const isFrequencyValid = frequency.trim() !== "";
    
        // Update the form validation status
        setFormValid(isCodeValid && isFrequencyValid);
      };
    
      useEffect(() => {
        validateForm();
      }, [resultScan, frequency, dateSetting]);
    
    
      const editSensor = () => {
     if(sensorId) {
          let data = {
          sensor_id: sensorId,
          code: resultScan,
          dataMapping: settingValues,
          frequency: frequency,
          lat: sensorCoords.lat,
          lon: sensorCoords.lon
        }
        if (formValid) {
          api.post('/sensor/edit-mapping', data)
            .then(response => {
              if (response.data.type === 'success') {
                swal(`${t('sensor_added')}`, {
                  icon: "success",
                })
                getSingleSensor()
              }
            }).catch(err => {
              swal({
                icon: 'error',
                title: t('Oops...'),
                text: t('Error')
              })
            })
    
        } else {
          swal({
            icon: "error",
            title: t("Error"),
            text: t("Please fill in all required fields."),
          });
        }}
      }

      let niv = ['Mv1', 'Mv2', 'Mv3']

      const onChangeHandlerDate = (value, name, label) => {
    
        setDateSetting(state => ({ ...state, [`${name}_${label}`]: value }), [])
      }
      const onChangeHandlerMax = (value, name, label) => {
        setMaxSetting(state => ({ ...state, [`${name}_${label}`]: value }), [])
      }
      const onChangeHandlerMin = (value, name, label) => {
        setMinSetting(state => ({ ...state, [`${name}_${label}`]: value }), [])
      }
    
      useEffect(() => {
        let dataArray = []
        dataArray.push({ date: dateSetting, min: minSetting, max: maxSetting })
        setSettingValues(dataArray)
      }, [dateSetting, minSetting, maxSetting])
    
    
    
      const Items = () => {
        let element = []
    
        for (let index = 0; index < niv.length; index++) {
          element.push(
            <tbody key={niv[index]}>
              <tr>
                <td>{niv[index]}</td>
                <td>
                  <input
                    name={'date'}
                    style={{ minHeight: 32, marginRight: 5, outline: 'none', border: '1px solid #e4e4e4' }}
                    type="date"
                    required
                    value={(dateSetting != null && typeof dateSetting[`Mv${index + 1}_date`] !== 'undefined') ? dateSetting[`Mv${index + 1}_date`] : ""}
                    onChange={e => onChangeHandlerDate(e.target.value, niv[index], 'date')}
                  />
                </td>
                <td>
                  <input
                    name={'min'}
                    style={{ minHeight: 32, marginRight: 5, outline: 'none', border: '1px solid #e4e4e4' }}
                    value={(minSetting != null && typeof minSetting[`Mv${index + 1}_min`] !== 'undefined') ? minSetting[`Mv${index + 1}_min`] : ""}
                    onChange={e => onChangeHandlerMin(e.target.value, niv[index], "min")}
                  />
                </td>
                <td>
                  <input
                    name={'max'}
                    style={{ minHeight: 32, marginRight: 5, outline: 'none', border: '1px solid #e4e4e4' }}
                    value={(maxSetting != null && typeof maxSetting[`Mv${index + 1}_max`] !== 'undefined') ? maxSetting[`Mv${index + 1}_max`] : ""}
                    onChange={e => onChangeHandlerMax(e.target.value, niv[index], "max")}
                  />
                </td>
              </tr>
            </tbody>
          )

        }
        return element
      }

      const filteredSensors = allSensors.filter(sensor =>
        !search.trim() || (sensor.code || '').toLowerCase().includes(search.trim().toLowerCase())
      )

  return (
    <>
            <Container fluid className="main-content-container supplier-sensors-page px-4">
                <Row noGutters className="page-header py-4 supsens-header">
                    <PageTitle
                        sm="4"
                        title={t('list_sensors')}
                        subtitle={t('my_actions')}
                        className="text-sm-left"
                    />
                </Row>
                <Card className="supsens-toolbar-card">
                    <Card.Body>
                        <Form.Group className="mb-0">
                            <label htmlFor="search" className="visually-hidden">{t('search_sensors')}</label>
                            <div className="supsens-search-group">
                                <i className="fas fa-magnifying-glass supsens-search-icon" aria-hidden="true" />
                                <Form.Control
                                    id="search"
                                    value={search}
                                    onChange={e => setSearch(e.target.value)}
                                    placeholder={t('search_by_code', { defaultValue: 'Search by code' })} />
                            </div>
                        </Form.Group>
                    </Card.Body>
                </Card>
                <Card className="supsens-content-card">
                    <div className="supsens-table-wrap">
                    <table className="table mb-0 text-center">
                        <thead>
                            <tr>
                                <th scope="col">{t('sensor_code')}</th>
                                <th scope="col">{t('user')}</th>
                                <th scope="col">{t('Actions')}</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan={4} className="supsens-table-empty" role="status" aria-live="polite">{t('loading')}</td>
                                </tr>
                            ) : filteredSensors.length === 0 ? (
                                <tr>
                                    <td colSpan={4} className="supsens-table-empty">
                                        <i className="fas fa-microchip" aria-hidden="true" />
                                        {t('no_data', { defaultValue: 'No sensors found' })}
                                    </td>
                                </tr>
                            ) : (
                                filteredSensors.map(sensor => {
                                    let nameUser = ''
                                    users.map(user=>{
                                        if(user.id=== sensor.user_id){
                                            nameUser = user.name
                                        }
                                    })
                                    return (
                                        <tr key={sensor.id}>
                                            <td><span className="supsens-code-badge">{sensor.code}</span></td>
                                            <td>{nameUser}</td>
                                            <td>
                                                {
                                                    sensor.deleted_at === null
                                                        ?
                                                        <ButtonGroup size="sm" className="mr-2">
                                                            <Button title={t('history')} aria-label={t('history')} onClick={() => { navigate(`/my-history/${sensor.code}`)}} variant="info"><i className="material-icons" aria-hidden="true">&#xe889;</i></Button>
                                                            <Button title={t('edit')} aria-label={t('edit')} onClick={() => getSingleSensorToModif(sensor.id)} variant="outline-secondary"><i className="material-icons" aria-hidden="true">&#xe3c9;</i></Button>

                                                        </ButtonGroup>
                                                        :
                                                        null
                                                }

                                            </td>
                                            <td>
                                            <Button variant="outline-primary" className="supsens-assign-btn" onClick={() => {getSingleSensor(sensor.id,'User')}}>{t('assign_to_user', { defaultValue: 'Assign to user' })}</Button>

                                            </td>
                                        </tr>

                                    )
                                })
                            )}

                        </tbody>
                    </table>
                    </div>
                </Card>
                {
        sensorId  && (
        <Row className='py-4'>
            <Col lg="12" md="8" sm="12" className="mb-4">
            <Card small className="h-100 supsens-edit-card">
                <Card.Header className="border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <h6 className="m-0">{t('sensor_setup')}</h6>
                    <div className="d-flex">
                    <Button
                    onClick={editSensor}
                    className="mb-2 mr-1 btn btn-success"
                    >
                    <i className="fa fa-check mx-2" aria-hidden="true"></i>
                    {t('save')}
                    </Button>
                    <Button
                    className="mb-2 mr-1 btn btn-danger"
                    onClick={() => setSensorId(null)}
                    >
                    <i className="fa fa-times mx-2" aria-hidden="true"></i>
                    {t('cancel')}
                    </Button>
                    </div>
                </Card.Header>
                <Card.Body className="pt-0 px-1">
                <Row className="p-2">
                    <Col lg="8" sm="12" md="12">
                    <Form>
                        <Row form>
                        <Col lg="6" md="12" sm="12" className="form-group">
                            <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined" size='small'>
                            <InputLabel htmlFor="outlined-adornment-password">{t('sensor_code')}</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type='text'
                                placeholder={t('sensor_code')}
                                value={resultScan}
                                endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                    aria-label={t('toggle_qr_scanner')}
                                    edge="end"
                                    >
                                    <QrCodeScannerIcon />
                                    </IconButton>
                                </InputAdornment>
                                }
                                label={t('sensor_code')}
                            />
                            </FormControl>
                        </Col>
                        <Col lg="6" md="12" sm="12" className="form-group">
                            <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined" size='small'>
                            <InputLabel htmlFor="outlined-adornment-password">{t('Frequency')}</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type='text'
                                placeholder={t('Frequency')}
                                value={frequency}
                                onChange={e => { setFrequency(e.target.value) }}
                                label={t('Frequency')}
                            />
                            </FormControl>
                        </Col>
                        </Row>
                        <Row form>
                        <Col lg="6" md="12" sm="12" className="form-group">
                            <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined" size='small'>
                            <InputLabel htmlFor="outlined-adornment-password">{t('lat')}</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type='text'
                                placeholder={t('lat')}
                                value={sensorCoords.lat}
                                onChange={e => setSensorCoords({ ...sensorCoords, lat: e.target.value })}
                                label={t('lat')}
                            />
                            </FormControl>
                        </Col>
                        <Col lg="6" md="12" sm="12" className="form-group">
                            <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined" size='small'>
                            <InputLabel htmlFor="outlined-adornment-password">{t('lon')}</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type='text'
                                placeholder={t('lon')}
                                value={sensorCoords.lon}
                                onChange={e => setSensorCoords({ ...sensorCoords, lon: e.target.value })}
                                label={t('lon')}
                            />
                            </FormControl>
                        </Col>
                        </Row>
                        <Row form>
                        <Col lg="12" md="12" sm="12">
                            <table className="table mb-0 border text-center  table-responsive-lg">
                            <thead className="bg-light">
                                <tr>
                                <th scope="col" className="border-0">{t('Date')}</th>
                                <th scope="col" className="border-0">{t('Min')} (%)</th>
                                <th scope="col" className="border-0">{t('Max')} (%)</th>
                                </tr>
                            </thead>
    
                            {Items()}
    
                            </table>
                        
                        </Col>
    
                        </Row>
    
                    </Form>
                    </Col>
                    <Col lg="4" md="12" sm="12" className="mt-1">
                        <table className="table mb-0 border text-center mt-2  table-responsive-lg">
                            <thead className="bg-light">
                            <tr>
    
                                <th scope="col" className="border-0">{t('Timezone')}</th>
                                <th scope="col" className="border-0">{t('Location')}</th>
                                <th scope="col" className="border-0">{t('Link to map')}</th>
                            </tr>
                            </thead>
                            <tbody>
    
                            <tr>
                                <td>
                                GMT +{sensorCoords.locationInfo.offset}
                                </td>
                                <td>
                                {sensorCoords.locationInfo.timezone_id}
                                </td>
                                <td>
                                <a href={sensorCoords.locationInfo.map_url} target="_blank" rel="noopener noreferrer">{t('view_position', { defaultValue: 'View position' })}</a>
                                </td>
                            </tr>
    
    
    
                            </tbody>
    
                        </table>
                    </Col>
    
                </Row>
                </Card.Body>
            </Card>
            </Col>
        </Row>

        ) 
                    }
            </Container>
            <Modal centered={true} show={toggle} onHide={() => setToggle(false)} dialogClassName="supsens-modal">
                        <Modal.Header className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div>
                                {t('sensor_code')} : {code}
                            </div>
                            <div className="d-flex">
                                <Button
                                    onClick={()  => assignSensorToUser(userUid,supplierUid)}
                                    className="mb-2 mr-1 btn btn-success"
                                >
                                    <i className="fa fa-check mx-2" aria-hidden="true"></i>
                                    {t('save')}
                                </Button>
                                <Button
                                    className="mb-2 mr-1 btn btn-danger"
                                    onClick={() => {setToggle(false)} }
                                >
                                    <i className="fa fa-times mx-2" aria-hidden="true"></i>
                                    {t('cancel')}
                                </Button>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className='d-flex justify-content-center'>
                                <Col lg='6' md='12' sm='12'>
                                    <Form.Group>
                                        <label htmlFor="users">{t('select_user_to_assign_sensor', { defaultValue: 'Select a user to assign sensor' })}</label>
                                            <Form.Select
                                            id="users"
                                            value={userUid}
                                            onChange={(e) => {setUserUid(e.target.value)} }
                                        >
                                            <option value="">{t('select_user', { defaultValue: 'Select User' })}</option>

                                            {
                                                users.map(user =>{

                                                    return <option key={user.uid} value={user.uid}>{user.name}</option>

                                                })
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
        
        
                        </Modal.Body>
                    </Modal>
        </>
  )
}

export default SupplierSensors
